<template>
  <Modal
    :show="show.restoreRevisionConfirm"
    action-text="Restore"
    @close="close"
    @action="confirm"
  >
    <template #title>
      Restore this revision
    </template>

    <template #content>
      This will replace the current job profile content with the content from this revision.
      Are you sure you want to continue?
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import Modal from '@/components/shared/Modal.vue';
import { useTracking } from '@/stores/tracking/tracking';

const { show, modalParams } = storeToRefs(useModals());
const { setModal } = useModals();
const { jobProfile } = storeToRefs(useCurrentJobProfile());

const close = () => setModal({ field: 'restoreRevisionConfirm', value: false });

const pendingRevisionUlid = computed(() => modalParams.value.restoreRevisionConfirm?.revisionUlid);

const confirm = async () => {
  const revisionUlid = pendingRevisionUlid.value;
  const profileUlid = jobProfile.value?.ulid;

  close();
  await useCurrentJobProfile().restoreRevision({ revisionUlid });

  if (revisionUlid) {
    useTracking().jpEditorRestoredRevision({
      ulid: profileUlid,
      revisionUlid,
    });

    setModal({ field: 'jobProfileCompare', value: false });
  }
};
</script>
